export const FILL = 'fill'
export const FIT = 'fit'

export const ROTATION_STEP = 90
export const ROTATION_FULL_CIRCLE = 360
